import FieldDefs from './AiAnswersFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import Alerts from '../../mixins/Alerts'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [Alerts],
    props: {
        domain: {
            type: String,
            required: true
        },
        db: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // Поля таблицы с локализацией заголовков.
            fields: doLangFields(this, "lang.report.aiAnswers", FieldDefs),
            // Дефолтная сортировка таблицы.
            sortOrder: [
                {
                    field: 'superwsk',
                    sortField: 'superwsk',
                    direction: 'desc'
                }
            ],
            additionalActions: [],
        }
    },
    computed: {
        self() {
            return this;
        },
        tableFields() {
            return this.fields.filter(field => !field.filterOnly);
        },
    },
}
